import { TeamMembershipService as OvermapTeamMembershipService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class TeamMembershipService extends OvermapTeamMembershipService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
